var map = {
	"./page-113.json": 80,
	"./page-117.json": 81,
	"./page-122.json": 82,
	"./page-125.json": 83,
	"./page-128.json": 84,
	"./page-131.json": 85,
	"./page-134.json": 86,
	"./page-7.json": 87,
	"./page-74.json": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;